import script from "./company-info-metrics.vue?vue&type=script&setup=true&lang=ts"
export * from "./company-info-metrics.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__